// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ShodanIcon = createSvgIcon(
  <svg
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    clipRule="evenodd"
    viewBox="0 0 1000 1000"
  >
    <path fill="none" d="M0 0h999.98v1000.03H0z" />
    <path
      fill="#d9182f"
      fillRule="nonzero"
      d="m498.22 450 41.45-28.82 96.4 28.82v53.72H498.23z"
    />
    <circle
      cx={3284.5}
      cy={3647.5}
      r={1101.5}
      fill="#d9182f"
      transform="translate(-126.32 -203.35)scale(.2453)"
    />
    <circle
      cx={3284.5}
      cy={3647.5}
      r={941.5}
      fill="#e9727a"
      transform="translate(-126.32 -203.35)scale(.2453)"
    />
    <circle
      cx={3284.5}
      cy={3647.5}
      r={719.5}
      fill="#f7f7f7"
      transform="translate(-126.32 -203.35)scale(.2453)"
    />
    <circle
      cx={1704.5}
      cy={2453.49}
      r={984.5}
      fill="#d9182f"
      transform="translate(-126.32 -203.35)scale(.2453)"
    />
    <circle
      cx={1704.5}
      cy={2453.49}
      r={841.5}
      fill="#e9727a"
      transform="translate(-126.32 -203.35)scale(.2453)"
    />
    <circle
      cx={1704.5}
      cy={2453.49}
      r={643.5}
      fill="#f7f7f7"
      transform="translate(-126.32 -203.35)scale(.2453)"
    />
    <path
      fill="#d9182f"
      fillRule="nonzero"
      d="M522.82 445.42A209.6 209.6 0 1 0 362.15 196.3l204.89 44.22z"
    />
    <path
      fill="#e9727a"
      fillRule="nonzero"
      d="M746.2 240.53c0 98.95-80.21 179.16-179.16 179.16S418.86 302.82 387.88 240.53c0-98.95 80.21-179.16 179.16-179.16S746.2 141.58 746.2 240.53"
    />
    <circle
      cx={2826.55}
      cy={1809.54}
      r={558.16}
      fill="#f7f7f7"
      transform="translate(-126.32 -203.35)scale(.2453)"
    />
  </svg>,
  "Shodan",
);
export default ShodanIcon;
